import MeritoButton from '../../../../components/common/MeritoButtons/MeritoButtons';
import styles from './BulkUpdateModal.module.scss'
import { Modal } from 'reactstrap';
import { RiExternalLinkLine as RedirectIcon } from 'react-icons/ri';
import { IoMdRefresh as RefreshIcon } from 'react-icons/io';
import { useEffect, useState } from 'react';
import { RestS } from '../../../../rest/rest-service';
import { LiaUserEditSolid } from "react-icons/lia";
import { getLocalUser } from '../../../../components/functions/utilities';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../../../redux/reduxHooks';
import { setBulkUpdateStatus } from '../../../../redux/financeStatement/financeStatement';

interface BulkUpdateState {
    modalState: boolean,
    spreadsheetData: any
}

type Props = {
    bulkUpdateState: BulkUpdateState;
    showTaxColumn: boolean;
    // setOpen: (value: boolean) => void;
    handleClose: ({ modalState, spreadsheetData }: BulkUpdateState) => void;
    productsFilter: { isMissingCosts: boolean, isMissingTaxRate: boolean, isProductSold: boolean, searchTerm: string, integrationPartner: string }
}

const BulkUpdateModal = ({ handleClose, showTaxColumn, productsFilter, bulkUpdateState }: Props) => {
    const [currentSpreadsheetDoc, setCurrentSpreadsheetDoc] = useState(null);
    const [prepSheetLoading, setPrepSheetLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [refreshSheetLoading, setRefreshSheetLoading] = useState(false);
    const [showEditedBy, setShowEditedBy] = useState(false);
    const currentUser = getLocalUser();
    const dispatch = useAppDispatch();

    const { bulkUpdateInProgress } = useAppSelector(state => state.financeStatement)

    const prepareSheet = async () => {
        try {
            const data: any = await RestS.prepareSheet({
                productsFilter: productsFilter
            });
            console.log('data', data)
            if (data) {
                setCurrentSpreadsheetDoc(data?.spreadsheetDoc);
            }
            return data;
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        if (bulkUpdateState?.modalState) {

            if (!bulkUpdateState?.spreadsheetData) {
                setCurrentSpreadsheetDoc(null);
                (async () => {
                    setPrepSheetLoading(true);
                    await prepareSheet();
                    setShowEditedBy(false);
                    setPrepSheetLoading(false);
                })()
            } else {
                setCurrentSpreadsheetDoc(bulkUpdateState?.spreadsheetData);
                setShowEditedBy(true);
            }
            console.log('coming here')
            setIsModalOpen(true);
        } else {
            setIsModalOpen(false)
        }
    }, [bulkUpdateState])

    // const handleModalClose = () => {
    //     setOpen(false);
    // }

    const openSpreadsheet = () => {
        if (currentSpreadsheetDoc) {
            window.open(`${currentSpreadsheetDoc?.spreadsheetUrl}`, "_blank")
        }
    }

    const refreshSpreadsheetData = async () => {
        try {
            setRefreshSheetLoading(true);
            dispatch(setBulkUpdateStatus(true))
            const refreshedData = await RestS.refreshSpreadsheetData();
            setTimeout(() => {
                if (refreshSheetLoading) {
                    console.log('executing backup bulk update process')
                    handleClose({ modalState: false, spreadsheetData: null });
                    setRefreshSheetLoading(false);
                }
            }, 10000); // backup approach if socket are not received
        } catch (error) {
            console.log('error', error);
            setRefreshSheetLoading(false);
            // setIsModalOpen(false);
        }
    }

    useEffect(() => {
        if (!bulkUpdateInProgress) {
            if (refreshSheetLoading) {
                handleClose({ modalState: false, spreadsheetData: null });
                // setIsModalOpen(false);
                setRefreshSheetLoading(false);
            }
        }
    }, [bulkUpdateInProgress])

    return (
        <Modal toggle={() => {
            handleClose({ modalState: false, spreadsheetData: null })
        }} backdrop={'static'} contentClassName={"bulk_edit_modal"} size={"lg"} centered isOpen={isModalOpen}>
            <div className={styles.rootContainer}>
                <div className={styles.headerContainer}>
                    <div className={styles.title}>
                        Bulk Update Product Costs
                    </div>
                </div>
                <div className={styles.bodyContainer}>
                    <div className={styles.stepperContainer}>
                        <div className={styles.stepRootContainer}>
                            <div className={styles.step}>
                                1
                            </div>
                            <div className={styles.stepperText}>
                                <div>
                                    <b>Open</b> the sheet using the Google email ID registered with Merito.
                                </div>
                                {showEditedBy && currentSpreadsheetDoc?.extraConfig?.lastEditedBy ? <div className={styles.subText}>
                                    <div className={styles.iconContainer}>
                                        <LiaUserEditSolid />
                                    </div>
                                    <div>
                                        {currentSpreadsheetDoc?.extraConfig?.lastEditedBy == currentUser?.id ?
                                            <>Last edited by you on {moment(currentSpreadsheetDoc?.extraConfig?.lastEditedTime).format("MMM DD, h:mm A")} IST</>
                                            : <>Last edited by <b>{currentSpreadsheetDoc?.extraConfig?.lastEditedByName}</b> on {moment(currentSpreadsheetDoc?.extraConfig?.lastEditedTime).format("MMM DD, h:mm A")} IST</>}
                                    </div>
                                </div> : null}
                            </div>
                            <div className={styles.btnContainer}>
                                <MeritoButton onClick={openSpreadsheet} showLoadingWithText={true} disabled={prepSheetLoading || !currentSpreadsheetDoc} loading={prepSheetLoading} isRounded={true} type='secondary-2' btnText={prepSheetLoading ? "Preparing Sheet" : "Open Sheet"} size='lg' icon={prepSheetLoading ? null : <RedirectIcon />} />
                            </div>
                        </div>

                        <div className={styles.stepRootContainer}>
                            <div className={styles.step}>
                                2
                            </div>
                            <div className={styles.stepperText}>
                                <div>
                                    <b>Update</b>  the cost for every product by editing the <b>“Unit Cost”</b>{showTaxColumn ? <b>, “GST”</b> : ''} and <b>“Packaging Cost”</b> columns.
                                </div>
                            </div>
                        </div>

                        <div className={styles.stepRootContainer}>
                            <div className={styles.step}>
                                3
                            </div>
                            <div className={styles.stepperText}>
                                <div>
                                    Once you are done, click <b>Refresh</b>.
                                </div>
                            </div>

                            <div className={styles.btnContainer}>
                                <MeritoButton onClick={refreshSpreadsheetData} isRounded={true} disabled={prepSheetLoading || refreshSheetLoading} type='secondary-2' showLoadingWithText={true} loading={refreshSheetLoading} btnText={refreshSheetLoading ? "Refreshing" : "Refresh"} size='lg' icon={refreshSheetLoading ? null : <RefreshIcon />} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.bottomContainer}>
                    <MeritoButton onClick={() => {
                        handleClose({ modalState: false, spreadsheetData: null })
                    }} isRounded={true} btnText="Close" size='lg' type='secondary-2' />
                </div>
            </div>
        </Modal>
    );
}

export default BulkUpdateModal